// @ts-nocheck
import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface GradientButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "success" | "danger" | "purple";
  size?: "default" | "sm" | "lg" | "icon";
  children: React.ReactNode;
  asChild?: boolean;
}

const GRADIENT_MAP = {
  primary: "bg-gradient-to-r from-blue-900 to-indigo-900 hover:from-blue-800 hover:to-indigo-800 text-white",
  success: "bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 text-white",
  danger: "bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-500 hover:to-rose-500 text-white",
  purple: "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white",
};

/**
 * GradientButton — the standard gradient CTA button used across the entire app.
 *
 * Replaces the 50+ instances of `bg-gradient-to-r from-blue-900 to-indigo-900`.
 * Default variant is "primary" (blue-to-indigo gradient).
 */
export const GradientButton = React.forwardRef<HTMLButtonElement, GradientButtonProps>(
  ({ variant = "primary", size, className, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        size={size}
        className={cn(GRADIENT_MAP[variant], className)}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

GradientButton.displayName = "GradientButton";
export default GradientButton;
